import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import * as utils from "../util/utils";
import { BaseRequestPolicy } from "./requestPolicy";
import { delay } from "../util/delay";
export function rpRegistrationPolicy() {
  var retryTimeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
  return {
    create: function create(nextPolicy, options) {
      return new RPRegistrationPolicy(nextPolicy, options, retryTimeout);
    }
  };
}
export var RPRegistrationPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(RPRegistrationPolicy, _BaseRequestPolicy);

  var _super = _createSuper(RPRegistrationPolicy);

  function RPRegistrationPolicy(nextPolicy, options) {
    var _this;

    var _retryTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;

    _classCallCheck(this, RPRegistrationPolicy);

    _this = _super.call(this, nextPolicy, options);
    _this._retryTimeout = _retryTimeout;
    return _this;
  }

  _createClass(RPRegistrationPolicy, [{
    key: "sendRequest",
    value: function sendRequest(request) {
      var _this2 = this;

      return this._nextPolicy.sendRequest(request.clone()).then(function (response) {
        return registerIfNeeded(_this2, request, response);
      });
    }
  }]);

  return RPRegistrationPolicy;
}(BaseRequestPolicy);

function registerIfNeeded(policy, request, response) {
  if (response.status === 409) {
    var rpName = checkRPNotRegisteredError(response.bodyAsText);

    if (rpName) {
      var urlPrefix = extractSubscriptionUrl(request.url);
      return registerRP(policy, urlPrefix, rpName, request) // Autoregistration of ${provider} failed for some reason. We will not return this error
      // instead will return the initial response with 409 status code back to the user.
      // do nothing here as we are returning the original response at the end of this method.
      .catch(function () {
        return false;
      }).then(function (registrationStatus) {
        if (registrationStatus) {
          // Retry the original request. We have to change the x-ms-client-request-id
          // otherwise Azure endpoint will return the initial 409 (cached) response.
          request.headers.set("x-ms-client-request-id", utils.generateUuid());
          return policy._nextPolicy.sendRequest(request.clone());
        }

        return response;
      });
    }
  }

  return Promise.resolve(response);
}
/**
 * Reuses the headers of the original request and url (if specified).
 * @param originalRequest - The original request
 * @param reuseUrlToo - Should the url from the original request be reused as well. Default false.
 * @returns A new request object with desired headers.
 */


function getRequestEssentials(originalRequest) {
  var reuseUrlToo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var reqOptions = originalRequest.clone();

  if (reuseUrlToo) {
    reqOptions.url = originalRequest.url;
  } // We have to change the x-ms-client-request-id otherwise Azure endpoint
  // will return the initial 409 (cached) response.


  reqOptions.headers.set("x-ms-client-request-id", utils.generateUuid()); // Set content-type to application/json

  reqOptions.headers.set("Content-Type", "application/json; charset=utf-8");
  return reqOptions;
}
/**
 * Validates the error code and message associated with 409 response status code. If it matches to that of
 * RP not registered then it returns the name of the RP else returns undefined.
 * @param body - The response body received after making the original request.
 * @returns The name of the RP if condition is satisfied else undefined.
 */


function checkRPNotRegisteredError(body) {
  var result, responseBody;

  if (body) {
    try {
      responseBody = JSON.parse(body);
    } catch (err) {// do nothing;
    }

    if (responseBody && responseBody.error && responseBody.error.message && responseBody.error.code && responseBody.error.code === "MissingSubscriptionRegistration") {
      var matchRes = responseBody.error.message.match(/.*'(.*)'/i);

      if (matchRes) {
        result = matchRes.pop();
      }
    }
  }

  return result;
}
/**
 * Extracts the first part of the URL, just after subscription:
 * https://management.azure.com/subscriptions/00000000-0000-0000-0000-000000000000/
 * @param url - The original request url
 * @returns The url prefix as explained above.
 */


function extractSubscriptionUrl(url) {
  var result;
  var matchRes = url.match(/.*\/subscriptions\/[a-f0-9-]+\//gi);

  if (matchRes && matchRes[0]) {
    result = matchRes[0];
  } else {
    throw new Error("Unable to extract subscriptionId from the given url - ".concat(url, "."));
  }

  return result;
}
/**
 * Registers the given provider.
 * @param policy - The RPRegistrationPolicy this function is being called against.
 * @param urlPrefix - https://management.azure.com/subscriptions/00000000-0000-0000-0000-000000000000/
 * @param provider - The provider name to be registered.
 * @param originalRequest - The original request sent by the user that returned a 409 response
 * with a message that the provider is not registered.
 */


function registerRP(_x, _x2, _x3, _x4) {
  return _registerRP.apply(this, arguments);
}
/**
 * Polls the registration status of the provider that was registered. Polling happens at an interval of 30 seconds.
 * Polling will happen till the registrationState property of the response body is "Registered".
 * @param policy - The RPRegistrationPolicy this function is being called against.
 * @param url - The request url for polling
 * @param originalRequest - The original request sent by the user that returned a 409 response
 * with a message that the provider is not registered.
 * @returns True if RP Registration is successful.
 */


function _registerRP() {
  _registerRP = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(policy, urlPrefix, provider, originalRequest) {
    var postUrl, getUrl, reqOptions, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            postUrl = "".concat(urlPrefix, "providers/").concat(provider, "/register?api-version=2016-02-01");
            getUrl = "".concat(urlPrefix, "providers/").concat(provider, "?api-version=2016-02-01");
            reqOptions = getRequestEssentials(originalRequest);
            reqOptions.method = "POST";
            reqOptions.url = postUrl;
            _context.next = 7;
            return policy._nextPolicy.sendRequest(reqOptions);

          case 7:
            response = _context.sent;

            if (!(response.status !== 200)) {
              _context.next = 10;
              break;
            }

            throw new Error("Autoregistration of ".concat(provider, " failed. Please try registering manually."));

          case 10:
            return _context.abrupt("return", getRegistrationStatus(policy, getUrl, originalRequest));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _registerRP.apply(this, arguments);
}

function getRegistrationStatus(_x5, _x6, _x7) {
  return _getRegistrationStatus.apply(this, arguments);
}

function _getRegistrationStatus() {
  _getRegistrationStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(policy, url, originalRequest) {
    var reqOptions, res, obj;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            reqOptions = getRequestEssentials(originalRequest);
            reqOptions.url = url;
            reqOptions.method = "GET";
            _context2.next = 5;
            return policy._nextPolicy.sendRequest(reqOptions);

          case 5:
            res = _context2.sent;
            obj = res.parsedBody;

            if (!(res.parsedBody && obj.registrationState && obj.registrationState === "Registered")) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", true);

          case 11:
            _context2.next = 13;
            return delay(policy._retryTimeout * 1000);

          case 13:
            return _context2.abrupt("return", getRegistrationStatus(policy, url, originalRequest));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getRegistrationStatus.apply(this, arguments);
}